import useSWRImmutable from "swr/immutable"

import { AppError } from "../../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../../errors/recognisedErrors"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getClientProtected } from "../../../clients/clients"
import { getDeviceReferenceMapper } from "../../../mappers/registerDevice/getDeviceReferenceMapper"
import { DEVICE_REFERENCE_CONFIG } from "../../../swrConfig"
import { TDeviceRef } from "../../../types/devices/ttr/getDeviceReferenceTypes"
import { GET_DEVICE_REFERENCE } from "../../../urls/private"

interface IUseDeviceRefOutput {
    isLoading: boolean
    isValidating: boolean
    error?: AppError
    deviceId?: string
    deviceRef?: string
}

/** Uses SWR to create and return a new device ID and device Ref in the backend.
 * This is then used to post the completed device form
 */
const useDeviceReference = (
    manufacturerId?: number | null
): IUseDeviceRefOutput => {
    const { isEnaSysAdmin } = useGetUserData()

    const fetchFormData = !isEnaSysAdmin || manufacturerId

    const { data, error, isLoading, isValidating } = useSWRImmutable(
        fetchFormData ? GET_DEVICE_REFERENCE(manufacturerId) : null,
        async (url: string): Promise<TDeviceRef> => {
            try {
                const response = await getClientProtected(url)
                return getDeviceReferenceMapper.map(response)
            } catch {
                throw invalidApiDataError("Failed to load Device ID")
            }
        },
        DEVICE_REFERENCE_CONFIG
    )

    return {
        deviceId: data?.deviceID,
        deviceRef: data?.deviceRef,
        isLoading,
        isValidating,
        error,
    }
}

export default useDeviceReference
